import { useImportDetail } from "hooks/import-management/useImport";
import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Modal, ModalBody, ModalHeader, Row } from "reactstrap";

const ImportDetail = props => {
  const { isOpenModal, dataDetail, toggleModal } = props;
  const { t } = useTranslation(["importManagement"]);
  const [exceptions, setExceptions] = useState([]);

  const onFetchImportDetailSuccess = response => {
    const arrayException = [];

    if (response?.exception && Array.isArray(response?.exception)) {
      response.exception.map(exceptionItem => {
        const index = arrayException.findIndex(
          item => item.exception == exceptionItem.exception
        );
        if (index === -1) {
          arrayException.push({
            exception: exceptionItem.exception,
            row: exceptionItem.row !== 0 ? `Dòng ${exceptionItem.row}` : "",
          });
        } else {
          arrayException[index].row += `, ${exceptionItem.row}`;
        }
      });
    }

    setExceptions(arrayException);
  };

  const { refetch: fetchImportDetail } = useImportDetail(
    {
      importId: dataDetail.importId,
    },
    onFetchImportDetailSuccess
  );

  useEffect(() => {
    if (isOpenModal) {
      fetchImportDetail();
    }
  }, [isOpenModal]);

  const renderException = () => {
    let messageException = ``;
    if (exceptions && Array.isArray(exceptions)) {
      exceptions.map((item, index) => {
        if (index === 0) {
          messageException += `- ${item.row ? item.row + ":" : ""} ${
            item.exception
          }`;
        } else {
          messageException += `\n\n- ${item.row ? item.row + ":" : ""} ${
            item.exception
          }`;
        }
      });

      return (
        <div
          style={{
            overflowWrap: "break-word",
            whiteSpace: "pre-wrap",
          }}
        >
          {messageException}
        </div>
      );
    }
    return null;
  };

  return (
    <React.Fragment>
      <Modal
        size="xl"
        isOpen={isOpenModal}
        role="dialog"
        autoFocus={true}
        centered={true}
        className="exampleModal"
        toggle={toggleModal}
      >
        <div className="modal-content">
          <ModalHeader toggle={toggleModal}>{t("title.detail")}</ModalHeader>
          <React.Fragment>
            <ModalBody>
              <Row className="row-cols-1 row-cols-lg-1 mt-3">
                {renderException()}
              </Row>
            </ModalBody>
          </React.Fragment>
        </div>
      </Modal>
    </React.Fragment>
  );
};

ImportDetail.propTypes = {
  isOpenModal: PropTypes.bool.isRequired,
  toggleModal: PropTypes.func.isRequired,
  dataDetail: PropTypes.object.isRequired,
};

ImportDetail.defaultProps = {
  isOpenModal: false,
  dataDetail: {},
};

export default ImportDetail;
